import * as React from 'react'
import { QuotationBase } from '../../../../services/json-schemas/base/quotation'
import { ItemQuotationBase } from '../../../../services/json-schemas/base/item_quotation'
import { modelRemoveSoftDeletableFromArray } from '../../../../services/models/models.service'
import QuotationFormItemQuotationComponent from './quotation-form-item-quotation.component'
import { OfferedServiceBase } from '../../../../services/json-schemas/base/offered_service'
import { OfferedServiceSubscriptionBase } from '../../../../services/json-schemas/base/offered_service_subscription'
import { CastingBase } from '../../../../services/json-schemas/base/casting'
import { I18nService } from '../../../../services/utils/i18n.service'
import { SupplierBase } from '../../../../services/json-schemas/base/supplier'

type ItemQuotation = Pick<ItemQuotationBase, 'description' | 'kind' | 'price_cents' | 'quantity' | 'tax_rules_group_id' | 'verbose_description'> & { id?: ItemQuotationBase['id'], _destroy?: boolean }

interface Props {
  isGeneratingInvoice?: boolean
  currentUserMarket: Pick<SupplierBase, 'taxes_for_select_react'>
  casting: Pick<CastingBase, 'casting_type'>
  quotation: Pick<QuotationBase, 'round_on_vat_price'> & { item_quotations_attributes: ItemQuotation[] }
  offeredService: Pick<OfferedServiceBase, 'employee_one_shot_fee_percentage' | 'employee_recurring_fee_percentage' | 'employee_product_fee_percentage'>
  offeredServiceSubscription: Pick<OfferedServiceSubscriptionBase, 'employee_one_shot_fee_percentage' | 'employee_recurring_fee_percentage' | 'employee_product_fee_percentage'> | null
  onChange: (body: Partial<Props['quotation']>) => void
  rightSubmitButton?: React.ReactNode
}

const i18nScoped = new I18nService(require('./quotation-form-unit-of-work-casting.component.yml'))

export default function QuotationFormUnitOfWorkCastingComponent (props: Props) {
  const { casting, quotation, currentUserMarket, offeredService, offeredServiceSubscription, isGeneratingInvoice, rightSubmitButton, onChange } = props
  const itemQuotations = quotation.item_quotations_attributes

  const setItemQuotationState = React.useCallback((index: number, body: Partial<ItemQuotation>) => {
    const itemQuotations = quotation.item_quotations_attributes.slice()
    itemQuotations[index] = { ...itemQuotations[index], ...body }
    onChange({ item_quotations_attributes: itemQuotations })
  }, [onChange, quotation.item_quotations_attributes])

  const removeItemQuotation = React.useCallback((itemQuotation: ItemQuotation) => {
    onChange({ item_quotations_attributes: modelRemoveSoftDeletableFromArray(itemQuotations, itemQuotation, '_destroy') })
  }, [itemQuotations, onChange])

  const addItemQuotation = React.useCallback(() => {
    onChange({ item_quotations_attributes: itemQuotations.concat({ id: null, description: null, kind: 'service', quantity: null, price_cents: null, tax_rules_group_id: null, verbose_description: null }) })
  }, [itemQuotations, onChange])

  return <>
    { itemQuotations
      .map((itemQuotation, index) => ({ itemQuotation, index }))
      .filter(_ => !_.itemQuotation._destroy)
      .map(({ itemQuotation, index }) => <div key={ index } className="u-mtm boxPod u-pls u-prs u-pbs" style={{ position: 'relative' }}>
        { itemQuotations.filter(_ => !_._destroy).length > 1 && <a
          id={ `item_quotation_${index}_destroy` }
          className="buttonDanger button--XS"
          onClick={ () => removeItemQuotation(itemQuotation) }
          style={{ position: 'absolute', top: '10px', right: '10px' }}>X</a> }

        <QuotationFormItemQuotationComponent
          index={ index }
          taxes={ currentUserMarket.taxes_for_select_react }
          quotation={ quotation }
          itemQuotation={ itemQuotation }
          casting={ casting }
          offeredService={ offeredService }
          offeredServiceSubscription={ offeredServiceSubscription }
          onChange={ body => setItemQuotationState(index, body) } />
      </div>) }

    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <button className="button button--S u-mts" onClick={ addItemQuotation }>
        <span className="icon icon-add"></span> { i18nScoped.t(isGeneratingInvoice ? 'add_item_invoice' : 'add_item_quotation') }
      </button>

      <div style={{ flexGrow: 1 }} />

      { rightSubmitButton }
    </div>
  </>
}
